// extracted by mini-css-extract-plugin
module.exports = {"wrap":"adminTitle_wrap__--fqo","title":"adminTitle_title__8KfUs"};